
const minutesStyle = { textAlign: 'right' }

export function RatesTable(){
  return (
    <table style={{ marginLeft: 'auto', marginRight: 'auto', fontSize: '22px'}}>
      {/* <thead>
        <tr>
          <th>Time</th>
          <th>Rate</th>
        </tr>
      </thead> */}
      <tbody>
        <tr>
          <td style={minutesStyle}>60 min</td>
          <td>$150</td>
        </tr>
        <tr>
          <td style={minutesStyle}>90 min</td>
          <td>$200</td>
        </tr>
        <tr>
          <td style={minutesStyle}>120 min</td>
          <td>$250</td>
        </tr> 
      </tbody>
    </table>
  );
}